// extracted by mini-css-extract-plugin
export default {"icon":"ScheduleGroup-module-f9a7c09a64fbf7bfe01d"};